import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { ITexasWristbandReportTypeConfigResponse } from '../store/configurations.types'
import { ConfigurationsService } from '../services/configurations.service'
import * as actions from '../store/configurations.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setTexasWristbandReportTypeConfig() {
  const serviceId: string = yield select(getServiceIdSelector)
  const configurationsService = new ConfigurationsService(serviceId)
  try {
    const response: ITexasWristbandReportTypeConfigResponse = yield call([
      configurationsService,
      configurationsService.getTexasWristbandReportTypeConfig,
    ])
    const { entity } = response
    if (entity && entity.length) {
      yield put(actions.setTexasWristbandReportTypeConfig(entity[0]))
    }
  } catch (e) {
    yield put(throwPcrException(`setTexasWristbandReportTypeConfig() error: ${e}`))
  }
}
export function* setTexasWristbandReportTypeConfigSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setTexasWristbandReportTypeConfig)
}
